import type { GameAccessMode } from "@/game/game-mode";

export type GameModePermissions = {
  mode: GameAccessMode;
  canToggleGmMode: boolean;
  /** แต่งบ้าน / วางชิ้น / ลบ / อัปโหลดคลัง — ผู้เล่นทำได้เอง */
  canEditHomeLayout: boolean;
  canManageCatalog: boolean;
  canEditMonsterPartStats: boolean;
  canGrantExp: boolean;
  canRecreateCharacter: boolean;
  canUseCashShop: boolean;
};

export function permissionsForGameMode(
  mode: GameAccessMode,
  canToggleGm: boolean,
): GameModePermissions {
  const isGm = mode === "gm" && canToggleGm;
  return {
    mode: isGm ? "gm" : "player",
    canToggleGmMode: canToggleGm,
    canEditHomeLayout: true,
    canManageCatalog: true,
    canEditMonsterPartStats: isGm,
    canGrantExp: isGm,
    canRecreateCharacter: isGm,
    canUseCashShop: true,
  };
}
